import React from 'react';
import { Line } from 'react-chartjs-2';
import compose from 'lodash/fp/compose';
import { withTranslation, withUserPreferences } from 'components/hoc';
import { useDarkMode } from 'context/DarkModeContext';
import styles from './chart.module.css';

const IncomeVsExpenditure = ({
  dataList_1_year,
  incomeCategoryList_1_year,
  expenseCategoryList_1_year,
  dataList_3_year,
  incomeCategoryList_3_year,
  expenseCategoryList_3_year,
  dataList_5_year,
  incomeCategoryList_5_year,
  expenseCategoryList_5_year,
  dataList_10_year,
  incomeCategoryList_10_year,
  expenseCategoryList_10_year,
  tr,
  trObj,
  fn,
  xfn,
}) => {
  const [interval, setInterval] = React.useState('year_1');
  const [selectedCategory, setSelectedCategory] = React.useState(
    'Income vs Expenditure',
  );

  const { isDarkMode } = useDarkMode();

  const income_expense =
    interval === 'year_1'
      ? dataList_1_year
      : interval === 'year_3'
      ? dataList_3_year
      : interval === 'year_5'
      ? dataList_5_year
      : interval === 'year_10'
      ? dataList_10_year
      : [];

  const icomeList =
    interval === 'year_1'
      ? incomeCategoryList_1_year
      : interval === 'year_3'
      ? incomeCategoryList_3_year
      : interval === 'year_5'
      ? incomeCategoryList_5_year
      : interval === 'year_10'
      ? incomeCategoryList_10_year
      : [];

  const expenseList =
    interval === 'year_1'
      ? expenseCategoryList_1_year
      : interval === 'year_3'
      ? expenseCategoryList_3_year
      : interval === 'year_5'
      ? expenseCategoryList_5_year
      : interval === 'year_10'
      ? expenseCategoryList_10_year
      : [];

  const chartData = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          color: isDarkMode ? '#ffffff' : '#68696a', // Change legend text color
          font: {
            size: 14,
          },
        },
      },
    },

    scales: {
      x: {
        ticks: {
          color: isDarkMode ? '#ffffff' : '#68696a', // Change X-axis text color
        },
        grid: {
          color: isDarkMode ? '#bbbbbb' : 'rgb(214, 215, 216)',
        },
      },
      y: {
        ticks: {
          color: isDarkMode ? '#ffffff' : '#68696a', // Change Y-axis text color
        },
        grid: {
          color: isDarkMode ? '#bbbbbb' : 'rgb(214, 215, 216)',
        },
      },
    },
  };

  const data = {
    labels: income_expense?.map((data) => data?.date),

    datasets: [
      {
        label: tr('Income'),
        type: 'line',
        borderColor: 'rgba(54, 162, 235, 1)',
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        data: income_expense?.map((p) => p?.income?.toFixed(2)) || [],
        fill: false,
        // tension: 0.4,
      },
      {
        label: tr('Expenditure'),
        type: 'line',
        borderColor: '#8e5ea2',
        backgroundColor: '#8e5ea2',
        data: income_expense?.map((p) => p?.expense?.toFixed(2)) || [],
        fill: false,
        // tension: 0.4,
      },
    ],
  };

  let data_ =
    selectedCategory === 'Income vs Expenditure'
      ? data
      : selectedCategory === 'Income'
      ? icomeList
      : expenseList;

  // 🔤 Translate backend dataset labels
  if (data_?.datasets) {
    data_ = {
      ...data_,
      datasets: data_.datasets.map((ds) => ({
        ...ds,
        label:
          ds.label && typeof ds.label === 'object' ? trObj(ds.label) : tr(ds.label),
      })),
    };
  }

  return (
    <div className={styles['line_chart_panel']}>
      <div className={styles['interval_btn_container']}>
        <select
          value={interval}
          onChange={({ target }) => setInterval(target.value)}
          style={{
            height: 38,
            transition: 'all ease-in-out 300ms',
            borderRadius: 2,
            background: '#d5e4f7',
            color: '#4576b3',
            fontSize: 14,
            overflow: 'hidden',
            fontWeight: 500,
            padding: 10,
            border: 0,
          }}
        >
          <option value="year_1">{tr('1 year')}</option>
          <option value="year_3">{tr('3 years')}</option>
          <option value="year_5">{tr('5 years')}</option>
          <option value="year_10">{tr('10 years')}</option>
        </select>

        <select
          value={selectedCategory}
          onChange={({ target }) => setSelectedCategory(target.value)}
          style={{
            height: 38,
            transition: 'all ease-in-out 300ms',
            borderRadius: 2,
            background: '#d5e4f7',
            color: '#4576b3',
            fontSize: 14,
            overflow: 'hidden',
            fontWeight: 500,
            padding: 10,
            border: 0,
          }}
        >
          <option value="Income vs Expenditure">
            {tr('Income vs Expenditure')}
          </option>

          <option value="Income">{tr('Income')}</option>

          <option value="Expenditure">{tr('Expenditure')}</option>
        </select>
      </div>

      <div className={styles['line_chart_canvas']}>
        <Line data={data_} options={chartData} />
      </div>
    </div>
  );
};

export default compose(withTranslation, withUserPreferences)(IncomeVsExpenditure);
